<p-card>
    @if (updateId && !copyId) {
        <p-tabs value="form">
            <p-tablist>
                <p-tab value="form">{{ 'service.payments.formTabHeader' | translate }}</p-tab>
                <p-tab value="medicalProcedures">{{ 'service.payments.medicalProceduresTabHeader' | translate }}
                </p-tab>
                @if (usePURO()) {
                    <p-tab value="puro">{{ 'service.payments.puro.label' | translate }}</p-tab>
                }
                @if (usePMUP()) {
                    <p-tab value="pmup">{{ 'service.payments.pmup.label' | translate }}</p-tab>
                }
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel value="form">
                    <app-service-payment-form
                        [puroForm]="usePURO() ? puroForm : null"
                        [pmupForm]="usePMUP() ? pmupForm : null"
                        [serviceId]="serviceId()"
                        [updateId]="updateId"
                    ></app-service-payment-form>
                </p-tabpanel>
                <p-tabpanel value="medicalProcedures">
                    <app-service-payment-medical-procedures
                        [serviceId]="serviceId()"
                        [servicePaymentId]="updateId"
                    ></app-service-payment-medical-procedures>
                </p-tabpanel>
                @if (usePURO()) {
                    <p-tabpanel value="puro">
                        <app-service-payment-puro
                            [form]="puroForm"
                            [formChange]="puroFormChange()"
                            [paymentId]="updateId"
                        ></app-service-payment-puro>
                    </p-tabpanel>
                } @else if (usePMUP()) {
                    <p-tabpanel value="pmup">
                        <app-service-payment-pmup
                            [form]="pmupForm"
                            [formChange]="pmupFormChange()"
                            [paymentId]="updateId"
                        ></app-service-payment-pmup>
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    }

    @if (!updateId) {
        <app-service-payment-form
            [serviceId]="serviceId()"
            [copyId]="copyId"
        ></app-service-payment-form>
    }
</p-card>
